import React from 'react';

import { ROUTES } from 'src/constants';
import { BaseBox, Flex, Text, BaseLink, Link, AccordionMenu, Delimiter } from 'src/kit';
import { Burger } from 'src/components';
import { Avatar } from '../../molecules/Avatar';
import { StyledMobileMenu, StyledBlackout } from './Header.styled';

export const MobileHeader = ({ authStore, userStore }) => {
  const [menuIsOpen, toggleOpenMenu] = React.useState(false);
  const closeMenu = React.useCallback(() => toggleOpenMenu(!menuIsOpen), [menuIsOpen]);
  React.useEffect(() => {
    if (menuIsOpen) {
      window.document.body.classList.add('noscroll');
    }
    return () => window.document.body.classList.remove('noscroll');
  }, [menuIsOpen]);
  const { logout } = authStore;
  const { user, isAdmin } = userStore;

  return (
    <>
      <Burger isOpen={menuIsOpen} onClick={closeMenu} mr={10} />
      <StyledBlackout isOpen={menuIsOpen} onClick={closeMenu} />
      <StyledMobileMenu isOpen={menuIsOpen}>
        <AccordionMenu>
          <AccordionMenu.AccordionItem>
            <AccordionMenu.AccordionItemToggle>
              <Flex p="10px 0 10px 15px" alignItems="center" fontSize={16}>
                <Avatar
                  src={user?.photo_thumbnail_url}
                  alt="photo"
                  firstName={user?.first_name}
                  size={25}
                  color="header.text"
                  bg="paleGreyTwo"
                />
                <Text fontWeight="bold">{user?.fullName}</Text>
              </Flex>
            </AccordionMenu.AccordionItemToggle>
            <AccordionMenu.AccordionItemContent>
              <BaseBox p="20px 0 20px 45px" bg="white">
                <Link mb={20} to={ROUTES.profile.general.base} onClick={closeMenu}>
                  My profile
                </Link>
                <BaseBox onClick={() => logout()}>Sign out</BaseBox>
              </BaseBox>
            </AccordionMenu.AccordionItemContent>
            <Delimiter bg="white" />
          </AccordionMenu.AccordionItem>
          {isAdmin && (
            <AccordionMenu.AccordionItem>
              <AccordionMenu.AccordionItemToggle>
                <BaseLink href={ROUTES.admin.base} p="10px 0 10px 45px" fontSize={16} fontWeight="bold">
                  Admin Panel
                </BaseLink>
                <Delimiter bg="white" />
              </AccordionMenu.AccordionItemToggle>
            </AccordionMenu.AccordionItem>
          )}
          {(user?.admin_notifications_count || user?.admin_job_board_notifications_count) && (
            <AccordionMenu.AccordionItem>
              <AccordionMenu.AccordionItemToggle>
                <Text p="10px 0 10px 45px" fontSize={16} fontWeight="bold">
                  Notifications
                </Text>
              </AccordionMenu.AccordionItemToggle>
              <AccordionMenu.AccordionItemContent>
                <BaseBox p="20px 0 20px 45px" bg="white">
                  {user?.admin_job_board_notifications_count && (
                    <BaseLink href={ROUTES.admin.job_board_notifications} mb={20}>
                      Job Board Notifications {user.admin_job_board_notifications_count > 0 && '+'}{' '}
                      {user?.admin_job_board_notifications_count}
                    </BaseLink>
                  )}
                  {user?.admin_notifications_count && (
                    <BaseLink href={ROUTES.admin.notifications}>
                      Notifications {user.admin_notifications_count > 0 && '+'} {user?.admin_notifications_count}
                    </BaseLink>
                  )}
                </BaseBox>
              </AccordionMenu.AccordionItemContent>
              <Delimiter bg="white" />
            </AccordionMenu.AccordionItem>
          )}
        </AccordionMenu>
      </StyledMobileMenu>
    </>
  );
};
